import { useContext } from 'react'
import { CatalogFilterContext, FiltersActionsContext, FiltersContext } from '../context/filters/context'
export function useCatalogFiltersActions() {
  return useContext(FiltersActionsContext) as CatalogFilterContext['actions']
}

export function useCatalogFiltersData() {
  return useContext(FiltersContext) as CatalogFilterContext['state']
}
